import organizationConstants from "constants/organizationConstants";

/**
 *
 * usersOrganizationsUrlWithoutParams = baseurl/users/organizations/{id}  - id optional
 *
 * usersOrganizationsUrl = baseUrl/users/organizations?search={}&title={}
 */
const usersOrganizationsUrlWithoutParams = (id = "") =>
  `${organizationConstants.ORGANIZATIONS_URL}/${id && `${id}/`}`;
const usersOrganizationsUrl = () => organizationConstants.ORGANIZATIONS_URL;
const filterOrganizationsUrl = () =>
  `${organizationConstants.ORGANIZATIONS_URL}/filter-by-title`;
const getFilteredOrganizations = () =>
  `${organizationConstants.ORGANIZATIONS_URL}/filter-by-title`;
const exportData = () => `${organizationConstants.ORGANIZATIONS_URL}/export`;
const organizationsUrl = () => organizationConstants.ORGANIZATIONS_URL;
const searchOrganizationsAlphabetical = () =>
  organizationConstants.SEARCH_ORGANIZATIONS_ALPHA_URL;
const searchOrganizationsNumeric = () =>
  organizationConstants.SEARCH_ORGANIZATIONS_NUMERIC_URL;

export default {
  usersOrganizationsUrlWithoutParams,
  usersOrganizationsUrl,
  searchOrganizationsAlphabetical,
  searchOrganizationsNumeric,
  getFilteredOrganizations,
  exportData,
  filterOrganizationsUrl,
  organizationsUrl,
};
